import { render } from "./menu.vue?vue&type=template&id=9b57df70&scoped=true"
const script = {}

import "./menu.vue?vue&type=style&index=0&id=9b57df70&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9b57df70"]])

export default __exports__